'use client';

import { useTranslations } from 'next-intl';
import { useState } from 'react';

import { UiKitButtonTab } from '@/ui-kit/button-tab';
import { BaseFieldProps } from '@/ui-kit/field';
import { UiKitInput } from '@/ui-kit/input';
import { UiKitTextarea } from '@/ui-kit/textarea';

import { styles } from './RecipientForm.styles';

type RecipientType = 'gift' | 'self';

export interface RecipientFormProps {
  getFieldProps: (name: string) => BaseFieldProps;
  initialProfile?: {
    phone?: string;
    email?: string;
  } | null;
}

export function RecipientForm({ getFieldProps, initialProfile }: RecipientFormProps) {
  const slots = styles();
  const t = useTranslations();

  const [recipientType, setRecipientType] = useState<RecipientType>('gift');

  return (
    <div className={slots.base()}>
      <input
        type="hidden"
        name="recipientType"
        value={recipientType}
      />
      <div className={slots.tabs()}>
        <UiKitButtonTab
          active={recipientType === 'gift'}
          onClick={() => setRecipientType('gift')}
        >
          {t('giftCard.recipientForm.sendAsGift')}
        </UiKitButtonTab>
        <UiKitButtonTab
          active={recipientType === 'self'}
          onClick={() => setRecipientType('self')}
        >
          {t('giftCard.recipientForm.sendToSelf')}
        </UiKitButtonTab>
      </div>

      {recipientType === 'gift' ? (
        <div className={slots.grid()}>
          <UiKitInput
            label={t('giftCard.recipientForm.phone')}
            mask="+7 (999) 999-99-99"
            required
            {...getFieldProps('phone')}
          />
          <UiKitInput
            label={t('giftCard.recipientForm.recipientEmail')}
            type="email"
            {...getFieldProps('email')}
          />
          <UiKitInput
            label={t('giftCard.recipientForm.yourName')}
            {...getFieldProps('yourName')}
          />
          <UiKitTextarea
            className={slots.greeting()}
            label={t('giftCard.recipientForm.greeting')}
            maxLength={240}
            {...getFieldProps('greeting')}
          />
        </div>
      ) : (
        <div className={slots.grid()}>
          <UiKitInput
            label={t('phone')}
            mask="+7 (999) 999-99-99"
            required
            value={initialProfile?.phone || ''}
            {...getFieldProps('phone')}
          />
          <UiKitInput
            type="email"
            label="Email"
            value={initialProfile?.email || ''}
            {...getFieldProps('email')}
          />
        </div>
      )}
    </div>
  );
}
